import { render, staticRenderFns } from "./VoucherAndRoomInformationSummary.vue?vue&type=template&id=552634c6&scoped=true"
import script from "./VoucherAndRoomInformationSummary.vue?vue&type=script&lang=js"
export * from "./VoucherAndRoomInformationSummary.vue?vue&type=script&lang=js"
import style0 from "./VoucherAndRoomInformationSummary.vue?vue&type=style&index=0&id=552634c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552634c6",
  null
  
)

export default component.exports